import { takeLatest, put, call } from 'redux-saga/effects';
import * as KibanaConfigActions from './action'
import { HTTP_HEADERS } from '../../constants';
import request from '../../components/Utils/httpHelper';
import { CORE_API } from '../../config';

export function* getkibanaConfig(action) {
    let requestUrl = `${CORE_API}/kibana/config/fetch`;
    try {
        const searchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(KibanaConfigActions.fetchKibanaConfigSuccess(searchResult.data));
    } catch (err) {
        yield put(KibanaConfigActions.fetchKibanaConfigFailure(err))
    }
}
export function* fetchKibanaConfig() {
    yield takeLatest(KibanaConfigActions.FETCH_KIBANA_CONFIG, getkibanaConfig);
}